// Icono de QR que usa la landing en el logo y en las tarjetas.
const QrMark = ({ size = 18 }) => {
  return (
    <svg aria-hidden="true" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="3" width="7" height="7"></rect>
        <rect x="14" y="3" width="7" height="7"></rect>
        <rect x="3" y="14" width="7" height="7"></rect>
        <path d="M14 14h3v3h-3zM20 14v.01M14 20h.01M17 20h4v-3"></path>
    </svg>
  )
}

export default QrMark
